import BaseModel from './BaseModel';

class LeadsEarningConfig extends BaseModel {
  constructor(data = {}, api_key = false) {
    super(data);
    if(api_key){
      this.setApiData(data);
    } else{
      this.updateData(data);
    }
  }

  updateData = (data) => {
    this.id = data.id;
    this.branch_id = data.branch_id || "";
    this.service_type_id = data.service_type_id || [];
    this.monthly_min_target = data.monthly_min_target || "";
    this.monthly_target = data.monthly_target || "";
    this.per_activation_rate = data.per_activation_rate || "";
    this.is_active = data.is_active === true || data.is_active === false ? data.is_active : true;
  }

  setApiData = (data) => {
    this.id = data.id;
    this.branch_id = data.branch_id || "";
    this.service_type_id = [data.service_type_id] || [];
    this.monthly_min_target = data.monthly_min_target || "";
    this.monthly_target = data.monthly_target || "";
    this.per_activation_rate = data.per_activation_rate || "";
    this.is_active = data.is_active === true || data.is_active === false ? data.is_active : true;
  }

  toApiJson = () => {
    this.completeValidation();
    return {
      lead_earning_configuration: this.service_type_id.map((item) => {
        return {
          id: this.id,
          branch_id: this.branch_id,
          service_type_id: item,
          monthly_min_target: this.monthly_min_target,
          monthly_target: this.monthly_target,
          per_activation_rate: this.per_activation_rate,
          is_active: this.is_active 
        }
      })
    }
  }

  toEditApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      lead_earning_configuration:{
        monthly_min_target: this.monthly_min_target,
        monthly_target: this.monthly_target,
        per_activation_rate: this.per_activation_rate,
        is_active: this.is_active
      }
    }
  }

  validations = (field) => {
    return {
      branch_id: () => {
        if(this[field] === "") {
          this.errors.branch_id = "This field is required and cannot be empty.";
        } else {
          delete this.errors.branch_id;
        }
      },
      service_type_id: () => {
        if(this[field].length === 0) {
          this.errors.service_type_id = "This field is required and cannot be empty.";
        } else {
          delete this.errors.service_type_id;
        }
      },
      monthly_min_target: () => {
        if(this[field] === "") {
          this.errors.monthly_min_target = "This field is required and cannot be empty.";
        } else if (parseInt(this[field]) > parseInt(this.monthly_target)) {
          this.errors.monthly_min_target = "Monthly minimum target should be less than monthly target.";
          this.errors.monthly_target = "Monthly target should be greater than monthly minimum target.";
        } else {
          delete this.errors.monthly_min_target;
          if(this.monthly_target !== ""){
            delete this.errors.monthly_target;
          }
        }
      },
      monthly_target: () => {
        if(this[field] === "") {
          this.errors.monthly_target = "This field is required and cannot be empty.";
        } else if (parseInt(this[field]) < parseInt(this.monthly_min_target)) {
          this.errors.monthly_min_target = "Monthly minimum target should be less than monthly target.";
          this.errors.monthly_target = "Monthly target should be greater than monthly minimum target.";
        } else {
          delete this.errors.monthly_target;
          if(this.monthly_min_target !== ""){
            delete this.errors.monthly_min_target;
          }
        }
      },
      per_activation_rate: () => {
        if(this[field] === "") {
          this.errors.per_activation_rate = "This field is required and cannot be empty.";
        } else {
          delete this.errors.per_activation_rate;
        }
      },
    }[field];
  }

  validate = (field) => {
    if (this.validations(field)) {
      this.validations(field)()
    }
  }
}

export default LeadsEarningConfig;
